{
  "footerAboutLink": "About RebelBase",
  "footerWorkWithUsLink": "Work With Us",
  "footer5DayChallLink": "5 Day Challenge",
  "footerContactLink": "Contact Us",
  "footerFAQLink": "FAQ",
  "footerPrivacyLink": "Privacy",
  "footerTermsLink": "Terms of Service",
  "footerWhoWeAreTitle": "Who We Are",
  "footerContactTitle": "Contact Us",
  "footerPrivacyTermsTitle": "Privacy and Terms",
  "footerSubscribeTopMessage": "Subscribe to our newsletter to stay updated.",
  "footerSubscribeBottomMessage": "Get a free 5-day Ideation Challenge Booklet.",
  "footerSubscribeButton": "subscribe",
  "footerEmail": "email"
}
